/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createType } from '../fn/router-type/create-type';
import { CreateType$Params } from '../fn/router-type/create-type';
import { getAllRouterTypes } from '../fn/router-type/get-all-router-types';
import { GetAllRouterTypes$Params } from '../fn/router-type/get-all-router-types';
import { PageDto } from '../models/page-dto';

@Injectable({ providedIn: 'root' })
export class RouterTypeAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllRouterTypes()` */
  static readonly GetAllRouterTypesPath = '/routers/type';

  /**
   * List all types.
   *
   * Returns a list of all types, paginated as specified.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllRouterTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRouterTypes$Response(params?: GetAllRouterTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
    return getAllRouterTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * List all types.
   *
   * Returns a list of all types, paginated as specified.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllRouterTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRouterTypes(params?: GetAllRouterTypes$Params, context?: HttpContext): Observable<PageDto> {
    return this.getAllRouterTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDto>): PageDto => r.body)
    );
  }

  /** Path part for operation `createType()` */
  static readonly CreateTypePath = '/routers/type';

  /**
   * Create a routerType.
   *
   * Creates a new router type.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createType$Response(params?: CreateType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createType(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a routerType.
   *
   * Creates a new router type.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createType(params?: CreateType$Params, context?: HttpContext): Observable<void> {
    return this.createType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
